import api from "../../utils/apiUserTienda";

export const getClientes = async () => {
  const res = await api.get("/api/tienda/clientes/obtener");
  return res.data;
};

export const getClienteById = async (clienteId) => {
  const res = await api.get(`/api/tienda/clientes/obtener/${clienteId}`);
  return res.data;
};

export const crearCliente = async (data) => {
  const res = await api.post("/api/tienda/clientes/crear", data);
  return res.data;
};

export const actualizarCliente = async (id, data) => {
  const res = await api.put(`/api/tienda/clientes/actualizar/${id}`, data);
  return res.data;
};
